import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import moment from 'moment';

const Config = require('../../config');

class ModalTraceability extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.state = {
			show:  false, 
            traceability:[],
			type:"",
			filter:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleChange(e){
		this.setState({filter: e.target.value});
	}

	handleShow(id, type){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'traceabilities/by_person?person_id='+id,{
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					traceability: response.res,
                    show: true,
                    type: type
				});
			}
		})
	}

	handleClose(){
		this.setState({
			show: false,
            traceability:[],
            type:""
		});
	}

	onFilter(row){
		var res = true;

		var str = moment(row.timestamp).format('DD/MM/YYYY HH:mm')+' '+row.description+' '+
				(this.state.type === 'donor' ? row.offers_id+' ' : row.petition_number)+
				(row.unit_number !== null ? row.unit_number+' ' : "")+
				row.user+' '+row.ip;

		if(row !== null){
			if(str.toUpperCase().indexOf(this.state.filter.toUpperCase()) !== -1){
				res = true
			}else{
				res = false;
			}
				
		}

		return res
	}

	render(){
		const {t} = this.props;

		return (
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose} className="s-modal-traceability">
		       	<Modal.Header closeButton>
		        	<Modal.Title>Trazabilidad</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
						<div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-4">
								<input name="filter" id="filter" value={this.state.filter} onChange={(e)=>this.handleChange(e)} 
									placeholder="Busqueda..." className="form-control"
								/>
							</div>
							
						</div>
		        		<div className="col-xs-12 form-group">
		        			<Table resposive hover style={{fontSize:12}}>
								<thead  style={{display:'table', width:'100%'}} >
									<tr>
										<th style={{width:'10%'}}>Fecha</th>
										<th style={{width:'50%'}}>Descripción</th>
                                        <th style={{width:'10%'}}>{this.state.type === 'donor' ? 'Ofrecimiento' : 'Petición' }</th>
										<th style={{width:'10%'}}>No. Unidad</th>
										<th>Usuario</th>
										<th>IP</th>
									</tr>
								</thead>
								<tbody style={{display:'block', height:'400px', overflowY:'auto'}}>
									{this.state.traceability.map((t, i)=>(
										this.onFilter(t) &&
											<tr key={i}>
												<td style={{width:'10%'}}>{moment(t.timestamp).format('DD/MM/YYYY HH:mm')}</td>
												<td style={{width:'51%'}}>{t.description}</td>
												<td style={{width:'10%'}}>{this.state.type === 'donor' ? t.offers_id : t.petition_number}</td>
												<td style={{width:'10%'}}>{t.unit_number}</td>
												<td>{t.user}</td>
												<td>{t.ip}</td>
											</tr>
									))}
								</tbody>
							</Table>
		        		</div>
					</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')} onClick={this.handleClose}  />
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations') (ModalTraceability);
